import http from '@/utils/request';

// 收款单列表
export const getReceiptList = (data = {}) => {
  const url = '/receipt/receipt/list';
  return http.post({
    url,
    data,
  });
};

// 获取关联的采购商收款单
export const getOrderReceiptInfos = (data = {}) => {
  return http.post({
    url: '/receipt/receipt/orderReceiptInfos',
    data,
  });
};

// 服务商收款单导出
export const EXPORT_PAYEERECEIPT = '/receipt/export/payeeReceipt';


// 收款详单详情
export const getReceiptDetail = (data = {}) => {
  const url = '/receipt/receipt/detaillist';
  return http.post({
    url,
    data,
  });
};

// 收款单详情-应收单列表
export const getDetailReceiptList = (data = {}) => {
  const url = '/receipt/receipt/detail/receives';
  return http.post({
    url,
    data,
  });
};

// 收款单详情-关联的分账记录
export const getDetailDivideRecords = (data = {}) => {
  const url = '/receipt/receipt/detail/divideRecords';
  return http.post({
    url,
    data,
  });
};

// 收款单确认/作废
export const setReceiptOper = (data = {}) => {
  const url = '/receipt/receipt/operSta';
  return http.post({
    url,
    data,
  });
};

// 收款单取消
export const cancelReceipt = (data = {}) => {
  const url = '/receipt/receipt/cancel';
  return http.post({
    url,
    data,
  });
};

// 收款记账簿
export const getBookFlowList = (data = {}) => {
  const url = '/receipt/receipt/receiptFlowList';
  return http.post({
    url,
    data,
  });
};


